// Is this `docusign_embed` widget pointing at a real DocuSign envelope, or at
// a provisioner placeholder?
//
// DocuSign envelope IDs are GUIDs. Anything else is a placeholder written at
// provision time to reserve the slot before a contract is sent
// ("SOR-2026-WHITELINE-001", "familidoo-sor-pending", ...).
//
// This started as a prefix allow-list (SOR-/SPA-/DEMO/PLACEHOLDER) duplicated
// in the webhook and the renderer, and drifted: the familidoo room was
// provisioned with an unlisted placeholder shape, so the Connect webhook's
// title-match adoption pass silently skipped its widgets and the room could
// never pick up an envelope. GUID-or-not needs no naming convention to be
// documented, followed, or kept in sync — hence one shared test, no list.
//
// Not a security boundary. It answers two questions only: may the webhook
// adopt this widget for an incoming envelope, and should the ID be shown to
// the supplier.

const ENVELOPE_GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isRealEnvelopeId(envelopeId: string | null | undefined): boolean {
    return typeof envelopeId === "string" && ENVELOPE_GUID.test(envelopeId);
}
